import React from 'react';
import { Box, Unstable_Grid2 as Grid, Typography, useTheme } from '@mui/material';
import Button from '../button/button';
import { FooterItemGridPropTypes } from './footerItemGrid.propTypes';
import commonUtil from '../../../utils/commonUtil';

/**
 * `FooterItemGrid` is a component that renders a responsive grid of footer items.
 * Each column can optionally have a title and a list of items, each of which is a button.
 */
export default function FooterItemGrid({ columns }) {
  const theme = useTheme();

  return (
    <Grid container spacing={2} sx={{ pt: 4, backgroundColor: theme.palette.primary.main }}>
      {columns.map((column, columnIndex) => (
        <Grid key={columnIndex} xs={12} sm={6} md={4} lg={2.4} sx={{ pb: 2, position: 'relative', zIndex: '1' }}>
          {column.title && (
            <Typography
              fontFamily="heading.fontFamily.primary"
              fontWeight={700}
              color="#68D3E3"
              sx={{ pb: '1.125rem', fontSize: "1.125rem !important" }}
              className='footer-menu-title'
            >
              {column.title}
            </Typography>
          )}
          {!column.title && columnIndex === 1 && (
            <Box sx={{ mt: '28px', pb: 2 }} />
          )}
          {column.items.map((item, itemIndex) => (
            <Box key={itemIndex}>
              <Button
                variant="text"
                color="#FFFFFF"
                fontFamily="body.fontFamily.secondary"
                fontWeight={400}
                sx={{
                  fontSize: '1rem',
                  lineHeight: '1.174rem',
                  padding: 0,
                  justifyContent: 'flex-start',
                  mb: '6px',
                  '&:hover': {
                    textDecoration: 'underline',
                    textDecorationColor: '#68D3E3',
                    boxShadow: 'none',
                    border: 'none',
                    outline: 'none',
                    background: 'none'
                  },
                }}
                onClick={() => commonUtil.handleRedirection(item.url)}
              >
                {item.label}
              </Button>
            </Box>
          ))}
        </Grid>
      ))}
    </Grid>
  );
}

FooterItemGrid.propTypes = FooterItemGridPropTypes;
